// extracted by mini-css-extract-plugin
export default {"icon":"FileTypeIcon_icon__QhH4Y","ext":"FileTypeIcon_ext__1COrZ"};